import { PartAnalysisSourceSchema, PartAnalysisSourceType } from "../types/PrismaZod";
import { is2DFile } from "./is2DFile";
import { is3DFile } from "./is3DFile";
import type { File } from "../types";

export const getSourceFromUrl = (
  file: Pick<File, "id" | "url" | "name">,
): PartAnalysisSourceType => {
  if (is3DFile(file)) {
    return PartAnalysisSourceSchema.enum.PYCAD;
  }
  if (is2DFile(file)) {
    return PartAnalysisSourceSchema.enum.PYPLAN;
  }
  throw new Error(`Invalid file: ${file.id}. Source cannot be determined.`);
};
